import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Title,
  Filler,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Title,
  Filler
);

const SingleGraph = ({graphData1}) => {

    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
        setIsMobile(true)
      }
    })
//   const graphData = {
//     labels: ["08-02-1993", "08-02-1993", "08-02-1993", "08-02-1993", "08-02-1993"],
//     datasets: [
//       {
//         label: "Revenue",
//         data: [3000, 200, 10, 400, 8000, 6000],
//         borderColor: "red",
//         backgroundColor: "rgba(192, 192, 42, 0.2)", // Light yellow fill
//         borderWidth: 1,
//         fill: true,
//         pointRadius: 1, // Set the point radius here
//       },
//       {
//         label: "Media Cost",
//         data: [2002, 3300, 3400, 2200, 7000, 8000],
//         borderColor: "green",
//         backgroundColor: "rgba(109, 220, 127, 0.25)", // Light green fill
//         borderWidth: 1,
//         fill: true,
//         pointRadius: 1, // Set the point radius here
//       },
//       {
//         label: "Margin",
//         data: [7700, 4000, 1100, 5000, 1000, 8000],
//         borderColor: "blue",
//         backgroundColor: "rgba(119, 122, 253, 0.25)", // Light blue fill
//         borderWidth: 1,
//         fill: true,
//         pointRadius: 1, // Set the point radius here
//       },
//     ],
//   };

  const graphData = {
    labels: graphData1?.deal_name,
    datasets: [
      {
        label: "Advertiser Cost",
        data: graphData1?.advertiser_cost,
        borderColor: "red",
        backgroundColor: "rgba(192, 192, 42, 0.2)", // Light yellow fill
        borderWidth: 1,
        fill: true,
        pointStyle: 'circle',
        pointRadius: 8, // Set the point radius here
        pointHoverRadius: 15,
        cubicInterpolationMode: 'monotone',
      },
      {
        label: "Media Cost",
        data: graphData1?.media_cost,
        borderColor: "green",
        backgroundColor: "rgba(109, 220, 127, 0.25)", // Light green fill
        borderWidth: 1,
        fill: true,
        pointStyle: 'circle',
        pointRadius: 6, // Set the point radius here
        pointHoverRadius: 15,
        cubicInterpolationMode: 'monotone',
      },
      {
        label: "Savings",
        data: graphData1?.savings,
        borderColor: "blue",
        backgroundColor: "rgba(119, 122, 253, 0.25)", // Light blue fill
        borderWidth: 1,
        fill: true,
        pointStyle: 'circle',
        pointRadius: 3, // Set the point radius here
        pointHoverRadius: 15,
        cubicInterpolationMode: 'monotone',
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: {
        display: true,
        position: 'top',
        labels: {
          font: {
            size: !isMobile ? 13 : 10, // Font size for legend labels
          },
        },
      },
      
      title: {
        display: true,
        text: " Detailed Graph of " + graphData1.name + " ( Deal Wise )",
        font: {
          size: !isMobile ? 18 : 12 // Adjust the title font size if needed
        }
      },
    },
    
    
    scales: {
      x: {
        ticks: {
          font: {
            size: !isMobile ? 12 : 8, // Font size for x-axis labels
          },
          
        },
      },
      y: {
        ticks: {
          font: {
            size: !isMobile ? 12 : 8, // Font size for y-axis labels
          },
          maxTicksLimit: 50,
        },
      },
    },
    defaultTooltip:{
      width: 5 // Change this value to set the width of the tooltip
    }
  };

  return (
    <>
      <Line options={options} data={graphData} />
    </>
  );
};

export default SingleGraph;